export const FIELD_TYPES = [
  { v: "text", label: "Short text", group: "Answer" },
  { v: "paragraph", label: "Paragraph", group: "Answer" },
  { v: "number", label: "Number", group: "Answer" },
  { v: "phone", label: "Phone", group: "Answer" },
  { v: "email", label: "Email", group: "Answer" },
  { v: "date", label: "Date", group: "Answer" },
  { v: "checkbox", label: "Yes / No checkbox", group: "Choice" },
  { v: "select", label: "Dropdown choice", group: "Choice" },
  { v: "radio", label: "Multiple choice (one)", group: "Choice" },
  { v: "multiselect", label: "Checkboxes (many)", group: "Choice" },
  { v: "signature", label: "Signature / initials line", group: "Answer" },
  { v: "initials", label: "Initials box (must match signer)", group: "Answer" },
  { v: "file", label: "File upload (PDF / photo)", group: "Answer" },
  { v: "heading", label: "Section heading", group: "Layout" },
  { v: "statictext", label: "Instructions text", group: "Layout" },
  { v: "bullets", label: "Bulleted list", group: "Layout" },
  { v: "numbered", label: "Numbered list", group: "Layout" },
];
export const CHOICE_TYPES = ["select", "radio", "multiselect"];
export const DISPLAY_TYPES = ["heading", "statictext", "bullets", "numbered"];
export const TEXTAREA_TYPES = ["statictext", "bullets", "numbered"];
export const FILE_ACCEPT = "application/pdf,image/jpeg,image/png,image/webp,image/heic,image/heif,image/gif";
export const WIDTHS = [
  { v: 12, label: "Full" },
  { v: 6, label: "½" },
  { v: 4, label: "⅓" },
  { v: 3, label: "¼" },
];
export const SPAN_CLS = { 12: "col-span-12", 6: "col-span-12 sm:col-span-6", 4: "col-span-12 sm:col-span-4", 3: "col-span-6 sm:col-span-3" };
export const newField = (type = "text") => ({ id: "", label: "", type, options: [], required: false, width: 12, help: "" });
export const SECOND_SIGNER_OPTIONS = [
  { v: "parent", label: "Second parent / guardian", hint: "Either guardian signs first from their parent app; the other one countersigns." },
  { v: "staff", label: "School countersignature", hint: "After the parent signs, a staff member countersigns from the Forms page." },
];
export const SECOND_SIGNER_LABEL = { parent: "Second parent / guardian", staff: "School countersignature" };
/** Initials must be 2–4 letters matching the signer's name (all initials, or first + last). */
export const initialsMatch = (val, name) => {
  const v = String(val || "").replace(/[^a-z]/gi, "").toUpperCase();
  const words = String(name || "").replace(/-/g, " ").split(/\s+/).filter((w) => /^[a-z]/i.test(w));
  if (v.length < 2 || v.length > 4 || words.length < 2) return false;
  const full = words.map((w) => w[0].toUpperCase()).join("");
  return v === full || v === words[0][0].toUpperCase() + words[words.length - 1][0].toUpperCase() || (v.length === 3 && v[0] === full[0] && v[2] === full[full.length - 1]);
};
